import React from 'react';
import RemoteAudioButton from './RemoteAudioButton';
import MuteButton from './MuteButton';
import EndCallButton from './EndCallButton';

const ConnectedControls = ({
  toggleRemoteAudio, isRemoteAudioMuted,
  toggleMute, isMuted, isSpeaking,
  endCall, isCallEnding
}) => {
  return (
    <div className="flex items-center gap-4 p-4 rounded-2xl backdrop-blur-sm bg-gradient-to-r from-white/5 to-white/3 border border-white/10 shadow-2xl">
      <RemoteAudioButton
        onClick={toggleRemoteAudio}
        isMuted={isRemoteAudioMuted}
      />

      {/* Divider with animation */}
      <div className="w-px h-12 bg-gradient-to-b from-transparent via-white/20 to-transparent"></div>

      <MuteButton
        onClick={toggleMute}
        isMuted={isMuted}
        isSpeaking={isSpeaking}
      />

      {/* Divider with animation */}
      <div className="w-px h-12 bg-gradient-to-b from-transparent via-white/20 to-transparent"></div>

      <EndCallButton
        onClick={endCall}
        isEnding={isCallEnding}
      />
    </div>
  );
};

export default ConnectedControls;
